<template>
	<div class="row voffset3">
		<div class="col-sm-2">
			<button type="button" class="btn btn-default btn-rounded"
			@click="changeStep('FIRST_STEP')"
			:disabled="auditTour1 || stepDisabled('FIRST_STEP') || auditTour2 || auditSatisfaction || end">Audit tour 1</button>
		</div>
		<div class="col-sm-2 col-sm-offset-1 col-lg-offset-0">
			<button type="button" class="btn btn-default btn-rounded"
			@click="changeStep('CRITIC_STEP')"
			:disabled="auditCritique || stepDisabled('CRITIC_STEP') || auditTour2 || auditSatisfaction || end">Audit critique</button>
		</div>

		<div class="col-sm-2 col-sm-offset-1 col-lg-offset-0">
			<button type="button" class="btn btn-default btn-rounded"
			@click="changeStep('SECOND_STEP')"
			:disabled="auditTour2 || stepDisabled('SECOND_STEP') || auditSatisfaction || end">Audit tour 2</button>
		</div>
		<div v-if="buttonStatistic" class="col-sm-1">
			<button type="button" class="btn btn-default btn-rounded"
			@click="openStatisticsModal()">Statistiques</button>
		</div>
		<div v-if="satisfactionSurveyEnabled" class="col-sm-2 col-sm-offset-1 col-md-offset-2 col-lg-offset-3">
			<button type="button" class="btn btn-default btn-rounded"
			@click="changeStep('SATISFACTION_SURVEY')"
			:disabled="auditSatisfaction || stepDisabled('SATISFACTION_SURVEY') || end">Enquête satisfaction</button>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			currentStep: function()	{
				return this.$store.state.user.currentStep;
			},
			auditTour1: function()	{
				return "FIRST_STEP" == this.currentStep;
			},
			auditCritique: function()	{
				return "CRITIC_STEP" == this.currentStep;
			},
			auditTour2: function()	{
				return "SECOND_STEP" == this.currentStep;
			},
			auditSatisfaction: function()	{
				return "SATISFACTION_SURVEY" == this.currentStep;
			},
			end: function() {
				return "END" == this.currentStep;
			},
			satisfactionSurveyEnabled: function() {
				return this.$store.state.user.satisfactionSurveyEnabled;
			},
			buttonStatistic: function() {
				if (this.$store.state.user.currentStep == "SECOND_STEP" || this.$store.state.user.currentStep == "SATISFACTION_SURVEY") {
					return true;
				} else {
					return false;
				}
			},
		},
		methods: {
			changeStep: function(newStep)	{
				this.$store.dispatch('changeStep', newStep);
			},
			openStatisticsModal: function(newStatus) {
		        this.$store.commit('DISPLAY_MODAL_STATISTICS', true);
			},
			stepDisabled: function(step)	{
				return !this.$store.state.user.userAnswers[step].length;
			}
		}
	};
</script>
